"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.concat = void 0;
var _ApolloLink = require("apollo-stack-hubspot/@apollo/client/link/core/ApolloLink");
var concat = exports.concat = _ApolloLink.ApolloLink.concat;